import Service from "../../services";

// initial state
const state = {
  overviewBanner: [
    {
      desktop_img: undefined,
      mobile_img: undefined,
      url: "",
    },
  ],
  homeBanner: [
    {
      desktop_img: undefined,
      mobile_img: undefined,
      url: "",
    },
  ],
  homeMain: {
    desktop_img: undefined,
    mobile_img: undefined,
    url: "",
  },
  internationalBanner: {
    desktop_img: undefined,
    mobile_img: undefined,
    url: "",
  },
  countryBanner: {
    desktop_img: undefined,
    mobile_img: undefined,
    url: "",
  },
  dataAndStatsBanner: {
    desktop_img: undefined,
    mobile_img: undefined,
  },
  researchReportBanner: {
    desktop_img: undefined,
    mobile_img: undefined,
  },
  aboutBanner: {
    desktop_img: undefined,
    mobile_img: undefined,
  },
  developerBanner: {
    desktop_img: undefined,
    mobile_img: undefined,
  },
};

// getters
const getters = {};

// actions
const actions = {
  onGetAllBanners({ commit }) {
    return Service.banner.getAllBanners().then((res) => {
      commit("setBanners", res);
      return res;
    });
  },
};

// mutations
const mutations = {
  setBanners(state, data) {
    for (const banner of data) {
      switch (banner.page) {
        case "Overview":
          // console.log("length", banner.desktop_img.length);
          // for (let x = 0; x < banner.desktop_img.length; x++) {
          //   if (!state.overviewBanner[x]) state.overviewBanner.push({});
          //   if (banner) {
          //     state.overviewBanner[x].desktop_img = banner.desktop_img[x];
          //     state.overviewBanner[x].mobile_img = banner.mobile_img[x];
          //     if (banner.url) {
          //       state.overviewBanner[x].url = banner.url[x];
          //     }
          //   }
          // }
          break;
        case "Home":
          // for (let x = 0; x < banner.desktop_img.length; x++) {
          //   if (!state.homeBanner[x]) state.homeBanner.push({});
          //   if (banner) {
          //     state.homeBanner[x].desktop_img = banner.desktop_img[x];
          //     state.homeBanner[x].mobile_img = banner.mobile_img[x];
          //     if (banner.url) {
          //       state.homeBanner[x].url = banner.url;
          //     } else {
          //       state.homeBanner[x].url = "";
          //     }
          //   }
          // }
          break;

        case "HomeMain":
          state.homeMain.desktop_img = banner.desktop_img;
          state.homeMain.mobile_img = banner.mobile_img;
          if (banner.url) {
            state.homeMain.url = banner.url;
          } else {
            state.homeMain.url = "";
          }
          break;

        case "International":
          state.internationalBanner.desktop_img = banner.desktop_img;
          state.internationalBanner.mobile_img = banner.mobile_img;
          if (banner.url) {
            state.internationalBanner.url = banner.url;
          } else {
            state.internationalBanner.url = "";
          }
          break;

        case "Country":
          state.countryBanner.desktop_img = banner.desktop_img;
          state.countryBanner.mobile_img = banner.mobile_img;
          if (banner.url) {
            state.countryBanner.url = banner.url;
          } else {
            state.countryBanner.url = "";
          }
          break;

        case "DataAndStats":
          state.dataAndStatsBanner.desktop_img = banner.desktop_img;
          state.dataAndStatsBanner.mobile_img = banner.mobile_img;
          break;

        case "ResearchAndReport":
          state.researchReportBanner.desktop_img = banner.desktop_img;
          state.researchReportBanner.mobile_img = banner.mobile_img;
          break;

        case "About":
          state.aboutBanner.desktop_img = banner.desktop_img;
          state.aboutBanner.mobile_img = banner.mobile_img;
          break;
        case "Developer":
          state.developerBanner.desktop_img = banner.desktop_img;
          state.developerBanner.mobile_img = banner.mobile_img;
          break;
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
